/*--------------------------------------------------------------*\
|| 							Favorites 							||
\*--------------------------------------------------------------*/

/*----------------------------------*\
|| 	1.0	File variables 				||
\*----------------------------------*/

var $doc = $(document),
  $window = $(window),
  logged_in = $("body").attr("data-user-logged-in");

/*----------------------------------*\
|| 	2.0	Functions 					||
\*----------------------------------*/

/**
 * add publication id to Favorites cookie
 *
 * @param    item        the name of the item that needs to be removed localStorage
 * @param    value       value of item added to the localStorage or existing array in localStorage
 **/
function addToCookie(cookieName, valueToAdd) {
  var name = cookieName,
    value = valueToAdd,
    data = readCookie(name),
    array;

  if (data) {
    array = JSON.parse(data);
    array.push(value);
  } else {
    array = [value];
  }

  var jsonString = JSON.stringify(array);

  // Create regex to replace " " / double quotes with nothing
  // Else we will have excess string such as [20, "44"]
  var replacer = new RegExp('("?)', "gi"),
    newValue = jsonString.replace(replacer, "");

  createCookie(name, newValue, 365);
}

/**
 * remove publication id from Favorites cookie
 *
 * @param    item        the name of the item that needs to be removed localStorage
 * @param    value       value of item added to the localStorage or existing array in localStorage
 **/
function removeFromCookie(cookieName, valueToRemove) {
  var name = cookieName,
    value = valueToRemove,
    data = readCookie(name);

  var reg = new RegExp("(,?" + value + ")", "gi"),
    tmpData = data.replace(reg, ""),
    newreg = new RegExp("(\\[,?)", "gi"),
    newValue = tmpData.replace(newreg, "[");

  createCookie(name, newValue, 365);
}

/**
 * Check if post is favorited
 *
 * @param 	id 			id of publication,
 * @param 	index 		Index of the array it's in
 * @param 	id 			id of publication, retreived via data-id attribute
 * @return 	boolean 	Should return true is favorited or false if not.
 **/
function isFavorited(id, index, array) {
  return new RegExp("\\b" + id + "\\b").test(string);
}

function getPosts() {
  $.ajax({
    type: "GET",
    url: KWR.ajaxurl,
    dataType: "json",
    data: {
      action: "getPost",
    },

    success: function(response) {
      if (response.success === true) {
        // console.log( 'succes' );
        // console.log( response );

        return response;
      }
    },
  });
}

/**
 * add publication id to user
 *
 * @param 	id 			id of publication,
 * @param 	index 		Index of the array it's in
 * @return 	boolean 	Should return true is favorited or false if not.
 **/
function setFavorite(ref, id) {
  $.when(callback()).done(addClasses);

  function callback() {
    if (logged_in == 1) {
      $.ajax({
        type: "POST",
        url: KWR.ajaxurl,
        dataType: "json",
        data: {
          action: "savePost",
          publication_id: id,
        },

        success: function(response) {
          if (response.success === true) {
            // console.log( 'succes' );
            // console.log( response );
          }
        },

        error: function(response) {
          // console.log( response );
        },
      });
    }
  }

  function addClasses() {
    addToCookie("favorites", id);

    var $pub = ref.parent().parent(".publication");
    ref.addClass("is-favorited");
    $pub.addClass("is-favorited");
  }
}

/**
 * remove publication id from user
 *
 * @param 	id 			id of publication,
 * @param 	index 		Index of the array it's in
 * @return 	boolean 	Should return true is favorited or false if not.
 **/
function removeFavorite(ref, id) {
  $.when(callback()).done(addClasses);

  function callback() {
    if (logged_in == 1) {
      $.ajax({
        type: "POST",
        url: KWR.ajaxurl,
        dataType: "json",
        data: {
          action: "removePost",
          publication_id: id,
        },

        success: function(response) {
          if (response.success === true) {
            // console.log( 'succes' );
            // console.log( response );
          }
        },

        error: function(response) {
          // console.log( response );
        },
      });
    } else {
      // console.log('skip ajax call');
    }
  }

  function addClasses() {
    removeFromCookie("favorites", id);

    var $pub = ref.parent().parent(".publication");
    ref.removeClass("is-favorited");
    $pub.removeClass("is-favorited");
  }
}

/*----------------------------------*\
|| 	3.0	Events				 		||
\*----------------------------------*/

$doc.ready(function(jQuery) {
  $doc.on("click", ".add-to-favorites", function(e) {
    e.preventDefault();

    var id = $(this).attr("data-id"),
      dropOver = $(this).next(),
      $pub = $(this)
        .parent()
        .parent(".publication");

    if (
      !$pub.hasClass("is-favorited") &&
      !$(this).hasClass("is-favorited") &&
      !$(this).attr("data-dropover")
    ) {
      setFavorite($(this), id);
    } else {
      if (dropOver.length) {
        dropOver.removeClass("open");
      }

      if (!$(this).attr("data-dropover")) {
        removeFavorite($(this), id);
      }
    }
  });

  var $body = document.getElementsByTagName("body");
  if ($body[0].classList.contains("single-publication")) {
    var $publications = document.getElementsByClassName("publication");

    // Loop all publications to check if it is favorited
    Array.prototype.forEach.call($publications, function(el) {
      // Some variables to use
      var $star = el.getElementsByClassName("add-to-favorites")[0],
        dataId = $star.getAttribute("data-id"),
        favorites,
        // storage is displayed as [23, 24, 25]
        storage = readCookie("favorites");

      if (storage !== null) {
        // We get an error if storage is null
        // The first and last favorite won't work unless we remove the brackets
        // We'll do that with regex
        var bracketsGone = new RegExp("(\\[,?)*(\\]?)", "gi"),
          trimStorage = storage.replace(bracketsGone, "");
        // Now split the string into an array
        favorites = trimStorage.split(",");
      }

      // For each item in the array, check if it matches the publication,
      // if it does, the user has favorited it.
      if (favorites) {
        for (var i = 0; i < favorites.length; i++) {
          if (favorites[i] == dataId) {
            el.className += " is-favorited";
          }
        }
      }
    });
  }
});

$doc.on("click", ".wpoa-login-button.button", function(e) {
  kwr_auth0.state &&
    createCookie(kwr_auth0.name, kwr_auth0.state, kwr_auth0.exp);
});
